import React from "react";

import _ from "lodash";
import { FormattedMessage } from "react-intl";

export type DisplayCustomer =
    | {
          firstName: string;
          middleName: string | undefined | null;
          lastName: string;
      }
    | {
          firstName?: string;
          lastName?: string;
          salutation?: string;
      };

function getMiddleName(customer: DisplayCustomer): string | undefined | null {
    return "middleName" in customer ? customer.middleName : undefined;
}

type Props = {
    customer: DisplayCustomer | undefined | null;
    displayMiddleName?: boolean;
};

class DisplayName extends React.Component<Props> {
    getSalutation() {
        if (this.props.customer && "salutation" in this.props.customer) {
            if (this.props.customer.salutation === "1") {
                return (
                    <React.Fragment>
                        {" "}
                        <FormattedMessage id="MR" />{" "}
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        {" "}
                        <FormattedMessage id="MS" />{" "}
                    </React.Fragment>
                );
            }
        }
        return null;
    }

    createDisplayedName() {
        const person = this.props.customer;

        if (!person || (!person.firstName && !("middleName" in person && person.middleName) && !person.lastName)) {
            return <span>-</span>;
        }

        const firstName = person.firstName ? person.firstName : "";
        const middleName = getMiddleName(person) || "";
        const lastName = person.lastName ? person.lastName : "";

        const fullName = this.props.displayMiddleName
            ? _.compact(_.chain([firstName, middleName, lastName]).value()).join(" ")
            : _.compact(_.chain([firstName, lastName]).value()).join(" ");
        const salutation = this.getSalutation();

        // Some countries (like NL) want to show the middle name all the time.
        // We then use the key without a space but with padding on the middle name itself.
        const optionalMiddleName = middleName ? " " + middleName : "";
        return getMiddleName(person) && this.props.displayMiddleName ? (
            <React.Fragment>
                {salutation}
                <FormattedMessage
                    id="EX_DISPLAYED_NAME_WITH_MIDDLENAME"
                    values={{
                        name: fullName,
                        firstName: firstName,
                        middleName: middleName,
                        lastName: lastName
                    }}
                />
            </React.Fragment>
        ) : (
            <React.Fragment>
                {salutation}
                <FormattedMessage
                    id="EX_DISPLAYED_NAME"
                    values={{
                        name: fullName,
                        firstName: firstName,
                        middleName: optionalMiddleName,
                        lastName: lastName
                    }}
                />
            </React.Fragment>
        );
    }

    render() {
        return this.createDisplayedName();
    }
}

const exported = {
    DisplayName
};

export default exported;
export { DisplayName };
